module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAQlBMVEUAAAD/Wkv/TkX/TEb/TEX/TEX/TUX/T0X/TUb/TEX/TEX/TkX/TEb/VVX/TEX/UFD/TUb/TEX/TUf/TUX/////TUZ8pXrqAAAAFnRSTlMAEVyhv9nzUb77/zvFA5AQutZdov/y7fK7xQAAAKpJREFUeAGN1EWCBSEQA9DgkHa7/1HHffidelucEvzkfIgp5xSDd+grtfFLqwX/DSP/GAf8Ns3smCf8sKzsWpcfczY+sH3NmlY+tE54N/PGjDcDbw14NfLW+PaHFAqASqECrlFoDjulHQelA5FSROKbs4tvErKelHHpSZftONPFA6WAnZK3hcUUYFuq6KQzp68uBF1S9uLUZa4bhm49tibW4fbjvR0eu8MPzxfILTOKc/oTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/del.png
// module id = mkbK
// module chunks = 44